import { render, staticRenderFns } from "./AddonInfoDialog.vue?vue&type=template&id=787eb9c0&"
import script from "./AddonInfoDialog.vue?vue&type=script&lang=js&"
export * from "./AddonInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports